module.exports = __webpack_public_path__ + "img/banner4.cdbfded9.jpg";